import { configureStore, getDefaultMiddleware } from 'redux-starter-kit';
import { combineReducers } from 'redux';
import reducers from './reducers';

export const store = configureStore({
  reducer: combineReducers(reducers),
  middleware: getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== 'production'
});

// sagaMiddleware.run(saga);
